import BackupScheduleResource from "./backupSchedule.resource";

const backupScheduleModule = angular
  .module("app.resources.backupSchedule", [])
  .service("BackupSchedule", BackupScheduleResource);

export default backupScheduleModule;



// WEBPACK FOOTER //
// ./src/resources/backupSchedule/backupSchedule.module.js